import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import API, { API_VERSION, REQUEST_METHOD } from '../../../api'
import STATUS from '../../../common/constants/reducer_statuses'

const initialState = {
  profiles: {},
}

export const fetchProfile = createAsyncThunk('contactProfile/fetchProfile', async (userId, { rejectWithValue }) => {
  try {
    const url = `users/${userId}/profile`
    const response = await API(url, API_VERSION.TWO).request(REQUEST_METHOD.GET)
    return response
  } catch (err) {
    return rejectWithValue(err._error)
  }
})


const contactProfileSlice = createSlice({
  name: 'contactProfiles',
  initialState,
  reducers: {

  },
  extraReducers: {
    [fetchProfile.pending]: (state, action) => {
      const userId = action.meta.arg
      if (!state.profiles[userId]) {
        state.profiles[userId] = {}
      }
      state.profiles[userId].status = STATUS.LOADING
    },
    [fetchProfile.fulfilled]: (state, action) => {
      const userId = action.meta.arg
      const { payload } = action
      if (!state.profiles[userId]) {
        state.profiles[userId] = {}
      }
      state.profiles[userId].status = STATUS.SUCCEEDED
      state.profiles[userId].data = payload
    },
    [fetchProfile.rejected]: (state, action) => {
      const userId = action.meta.arg
      const { payload } = action
      if (!state.profiles[userId]) {
        state.profiles[userId] = {}
      }
      state.profiles[userId].status = STATUS.FAILED
      state.profiles[userId].error = payload
    },
  },
})

// export const {
// } = contactProfileSlice.actions

export default contactProfileSlice.reducer
